import { filter, takeUntil } from 'rxjs/operators';
import { Component, ViewChildren, QueryList, HostListener, OnDestroy, OnChanges, SimpleChanges, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Constant } from 'src/app/constant/constant';
import { LeadService } from 'src/app/services/lead.service';
import { ProductService } from 'src/app/services/product.service';
import { FieldConfig } from '../field-interface';
import { CompaniesService } from 'src/app/services/companies.service';
import { TagesStatusService } from 'src/app/services/tages-status.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { LoaderService } from 'src/app/services/loader.service';
import { Subject } from 'rxjs';
import { RealEstatePropertyService } from 'src/app/services/real-estate-property.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';

@Component({
  selector: 'calsoft-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss']
})
export class AutocompleteComponent implements OnDestroy, OnChanges {

  sanitizedUrl: string = '';

  url = '';


  field: FieldConfig['eavAttribute'];
  group: UntypedFormGroup;

  leadList: any = [];
  companyList: any = [];
  tagList: any = [];
  type: any = 5;

  isOptionSelected: boolean = false;
  leadId: any;
  leadIdDisplay: boolean = false;
  companyIdDisplay: boolean = false;
  DealsCompanyDisplay: boolean = false;

  tagIdDisplay: boolean = false;
  leadName: any;
  productList: any = [];
  propertyList: any = [];
  propertyIdDisplay: boolean = false;

  separatorKeysCodes: number[] = [ENTER, COMMA];
  propertyCtrl: UntypedFormControl = new UntypedFormControl('');
  selectedProperties: any[] = [];
  @ViewChild('propertyInput') propertyInput: ElementRef<HTMLInputElement>;

  // display control and local filtered list for converting select -> autocomplete
  displayControl: UntypedFormControl = new UntypedFormControl('');
  fieldTypeListLocal: any[] = [];
  filteredFieldTypeList: any[] = [];

  @ViewChildren(MatAutocompleteTrigger) autocompleteTriggers: QueryList<MatAutocompleteTrigger>;
  // store attached scroll listeners so we can remove them later
  private _scrollableListeners: Array<{ el: any, handler: EventListener }> = [];

  ngOnDestroy(): void {
    this.detachScrollListeners();
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['group'] || changes['field']) {
      if (this.isPropertyField()) {
        this.propertyIdDisplay = true;
        this.syncPropertyControl();
      }
    }
  }


  constructor(private productService: ProductService,
    private router: Router,
    private route: ActivatedRoute,
    private leadService: LeadService,
    private tagesStatusService: TagesStatusService,
    private companiesService: CompaniesService,
    private snackBar: MatSnackBar,
    private loaderService: LoaderService,
    private cdr: ChangeDetectorRef,
    private realEstatePropertyService: RealEstatePropertyService
  ) {
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  ngOnInit() {

    if (this.field.frontendLabel == 'Company') {

      if (this.group.value.CompanyId > 0) {

        this.isOptionSelected = true;
      }

    }
    if (this.field.frontendLabel == 'Company') {
      if (this.router.url.includes('/add-edit-deals-company/')) {
        if (this.route.snapshot.params['leadId'] != undefined) {
          this.companyIdDisplay = true;

          this.getAllCompanyDetails(this.route.snapshot.params['leadId'])
        }
        else {
          this.companyIdDisplay = true;
        }

      } else {
        this.companyIdDisplay = true;
      }

      if (this.router.url.includes('/add-edit-deals/')) {
        if (this.route.snapshot.params['companyId'] != undefined) {


          this.getAllCompanyDetails(this.route.snapshot.params['companyId'])
        }


      }
    }

    if (this.field.frontendLabel == 'Lead Name') {
      if (this.router.url.includes('/add-edit-deals/')) {
        if (this.route.snapshot.params['leadId'] != undefined) {
          this.leadIdDisplay = true;

          this.getAllLeadDetails(this.route.snapshot.params['leadId'])
        } else {
          this.leadIdDisplay = true;
        }

      } else {
        this.leadIdDisplay = true;
      }
    }

    if (this.isPropertyField()) {

      console.log(this.group);


      this.propertyIdDisplay = true;
      this.syncPropertyControl();
      if (this.group) {
        this.group.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
          this.syncPropertyControl();
        });
      }
    }

    // initialize field autocomplete helper
    this.initFieldAutocomplete();

  }

  isPropertyField(): boolean {
    if (!this.field) return false;
    const code = (this.field.attributeCode || '').toLowerCase();
    const label = (this.field.frontendLabel || '').toLowerCase();
    return code === 'propertyname' || code === 'propertyid' || code === 'primaryplan' || code === 'property' || code === 'property_name' || code === 'property_id' ||
      label === 'property name' || label === 'property' || label === 'primary plan' || label === 'primaryplan' || label === 'property id';
  }

  lastFetchedPropertyId: any = null;

  syncPropertyControl(): void {
    if (!this.isPropertyField() || !this.group) return;

    const propVal = this.group.get('PropertyName')?.value ||
      this.group.get('propertyName')?.value ||
      this.group.get('Property')?.value ||
      this.group.get('property')?.value ||
      (this.isPropertyField() ? this.group.get(this.field.attributeCode)?.value : null);

    const propIdVal = this.group.get('PropertyId')?.value ||
      this.group.get('propertyId')?.value ||
      this.group.get('PrimaryPlan')?.value ||
      this.group.get('primaryPlan')?.value;

    if (propVal && typeof propVal === 'string' && propVal.trim().length > 0 && isNaN(Number(propVal.replace(/,/g, '')))) {
      const names = propVal.split(',').map(s => s.trim()).filter(s => s.length > 0);
      const ids = propIdVal ? (propIdVal + '').split(',').map(s => s.trim()) : [];

      const newSelected: any[] = [];
      names.forEach((name, idx) => {
        const id = ids[idx] || null;
        if (!newSelected.some(p => p.name === name || p.propertyName === name)) {
          newSelected.push({ entityId: id, id: id, name: name, propertyName: name });
        }
      });

      if (newSelected.length > 0) {
        this.selectedProperties = newSelected;
        this.isOptionSelected = true;
        this.cdr.detectChanges();
      }
    } else if (propIdVal && (Number(propIdVal) > 0 || (typeof propIdVal === 'string' && propIdVal.trim().length > 0))) {
      const ids = (propIdVal + '').split(',').map(s => s.trim()).filter(s => s.length > 0);
      const missingIds = ids.filter(id => !this.selectedProperties.some(p => (p.entityId == id || p.id == id)));
      if (missingIds.length > 0) {
        this.isOptionSelected = true;
        missingIds.forEach(id => {
          if (this.lastFetchedPropertyId !== id) {
            this.getAllPropertyDetails(id);
          }
        });
      }
    }
  }


  /**
   * Initialize local field-type list and display control for converting select -> autocomplete.
   */
  initFieldAutocomplete(): void {
    if (!this.field) return;
    this.fieldTypeListLocal = (this as any).fieldTypeList || this.field.eavAttributeOption || [];
    // Do not show any suggestions initially — only populate filtered list when user types
    this.filteredFieldTypeList = [];

    const initialId = this.group?.get(this.field.attributeCode)?.value;
    if (initialId) {
      const m = (this.fieldTypeListLocal || []).find(x => x.optionId == initialId);
      if (m) {
        this.displayControl.setValue(m.eavAttributeOptionValue && m.eavAttributeOptionValue[0] ? m.eavAttributeOptionValue[0].value : '');
        this.isOptionSelected = true;
      }
    }

    this.displayControl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(val => {
      const q = (val || '').toString().trim().toLowerCase();
      // When the input is empty, do not suggest anything. Only show filtered
      // results once the user types a non-empty query.
      if (!q) {
        this.filteredFieldTypeList = [];
      } else {
        this.filteredFieldTypeList = (this.fieldTypeListLocal || []).filter(item => ((item.eavAttributeOptionValue && item.eavAttributeOptionValue[0]?.value) || '').toString().toLowerCase().includes(q));
      }
    });
  }

  onGenericInput(event: Event): void {
    let inputElement = event.target as HTMLInputElement;
    const raw = inputElement.value || '';
    const noLeading = raw.replace(/^\s+/, '');
    if (noLeading !== raw) {
      inputElement.value = noLeading;
      this.displayControl.setValue(noLeading);
    }
    this.attachScrollListenersForElement(inputElement);
  }

  onFieldOptionSelected(event: any, option: any) {
    if (event && event.isUserInput !== false && option) {
      this.isOptionSelected = true;
      if (this.group && this.group.get(this.field.attributeCode)) {
        this.group.get(this.field.attributeCode).setValue(option.optionId);
      }
      const label = option.eavAttributeOptionValue && option.eavAttributeOptionValue[0] ? option.eavAttributeOptionValue[0].value : '';
      this.displayControl.setValue(label);
    }
  }

  onGenericAutocompleteClosed() {
    const typed = (this.displayControl.value || '').toString().trim();
    if (!typed) return;
    const match = (this.fieldTypeListLocal || []).find(opt => ((opt.eavAttributeOptionValue && opt.eavAttributeOptionValue[0]?.value) || '').toString().toLowerCase() === typed.toLowerCase());
    if (!match) {
      this.displayControl.reset();
      if (this.group && this.group.get(this.field.attributeCode)) this.group.get(this.field.attributeCode).reset();
      this.isOptionSelected = false;
    }
  }

  clearGenericField() {
    this.isOptionSelected = false;
    this.displayControl.reset();
    if (this.group && this.group.get(this.field.attributeCode)) this.group.get(this.field.attributeCode).reset();
  }

  clearInputLead() {
    this.isOptionSelected = false;

    this.group.get('LeadId')?.reset();

    this.group.get('LeadName')?.reset();

  }

  clearInputCompany() {
    this.isOptionSelected = false;

    this.group.get('CompanyId')?.reset();

    this.group.get('Company')?.reset();
    this.cdr.detectChanges();
  }
  clearInputDealsCompany() {
    this.isOptionSelected = false;

    this.group.get('CompanyId')?.reset();

    this.group.get('Company')?.reset();

  }
  clearInputTags() {
    this.isOptionSelected = false;

    this.group.get('TagId')?.reset();

    this.group.get('TagName')?.reset();

  }

  onInputPaitent(event: Event): void {
    let inputElement = event.target as HTMLInputElement;
    // remove leading spaces immediately while typing
    const raw = inputElement.value || '';
    const noLeading = raw.replace(/^\s+/, '');
    if (noLeading !== raw) {
      inputElement.value = noLeading;
    }
    let inputValue = noLeading.trim();

    if (inputValue.length > 0) {
      this.getLeadData(inputValue);
    }

    // attach scroll listeners for this input so scrolls inside ancestor containers close the panel
    this.attachScrollListenersForElement(inputElement);


  }

  onCompanyInputPaitent(event: Event): void {
    let inputElement = event.target as HTMLInputElement;
    // remove leading spaces as user types
    const raw = inputElement.value || '';
    const noLeading = raw.replace(/^\s+/, '');
    if (noLeading !== raw) {
      inputElement.value = noLeading;
      // update the form control value so model/UI stay in sync
      if (this.group && this.group.get('Company')) {
        this.group.get('Company').setValue(noLeading);
      }
    }
    let inputValue = noLeading.trim();

    if (inputValue.length > 0) {
      this.getCompanyData(inputValue);

    }

    this.attachScrollListenersForElement(inputElement);




  }
  onDealsCompanyInputPaitent(event: Event): void {
    let inputElement = event.target as HTMLInputElement;
    // remove leading spaces as user types
    const raw = inputElement.value || '';
    const noLeading = raw.replace(/^\s+/, '');
    if (noLeading !== raw) {
      inputElement.value = noLeading;
    }
    let inputValue = noLeading.trim();

    if (inputValue.length > 0) {

      this.getCompanyData(inputValue);
    }

    this.attachScrollListenersForElement(inputElement);


  }
  onTagsInputPaitent(event: Event): void {
    let inputElement = event.target as HTMLInputElement;
    // remove leading spaces as user types
    const raw = inputElement.value || '';
    const noLeading = raw.replace(/^\s+/, '');
    if (noLeading !== raw) {
      inputElement.value = noLeading;
    }
    let inputValue = noLeading.trim();

    if (inputValue.length > 0) {

      this.getTagsData(inputValue);
    }

    this.attachScrollListenersForElement(inputElement);


  }

  onLeadSelected(event, option) {
    if (event && event.isUserInput != false) {
      this.isOptionSelected = true;
      const displayName = (option.name && option.name.trim()) ? option.name.trim() : (option.phoneNumber || option.mobile || option.phone || option.secondaryphoneno || '');
      if (this.group && this.group.get('LeadId')) {
        this.group.get('LeadId').setValue(option.entityId);
      }
      if (this.group && this.group.get('LeadName')) {
        this.group.get('LeadName').setValue(displayName);
      }
    }
  }

  onCompanySelected(event, option) {
    if (event.isUserInput != false) {
      this.isOptionSelected = true;
      if (this.group.get('CompanyId')) {
        this.group.get('CompanyId').setValue(option.entityId);
        this.group.get('CompanyId').updateValueAndValidity();
      }
      if (this.group.get('Company')) {
        this.group.get('Company').setValue(option.name);
        this.group.get('Company').updateValueAndValidity();
      }
      if (this.field && this.field.attributeCode && this.field.attributeCode !== 'Company' && this.group.get(this.field.attributeCode)) {
        this.group.get(this.field.attributeCode).setValue(option.name);
        this.group.get(this.field.attributeCode).updateValueAndValidity();
      }
      this.cdr.detectChanges();
    }
  }

  onTagsSelected(event, option) {
    if (event.isUserInput != false) {
      this.isOptionSelected = true;
      this.group.get('TagId').setValue(option.entityId);
      this.group.get('TagName').setValue(option.name);

    }
  }
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  getLeadData(value) {


    let sortParam = 'updatedDate' + "," + Constant.Dsc;

    let search = "name:" + '*' + value.trim() + '*'
      + "' OR phoneNumber:" + '*' + value.trim() + '*'
      + "' OR ownerEmail:" + '*' + value.trim() + '*' + "' "


    if (search != '') {
      this.productService.getLeadBySearch(search, this.page, this.size, sortParam).subscribe(
        res => {

          this.leadList = res['content'];




        },
        error => {

        })
    }

  }

  getCompanyData(value) {


    let sortParam = 'updatedDate' + "," + Constant.Dsc;

    let search = "name:" + '*' + value.trim() + '*'
      + "' OR phoneNumber:" + '*' + value.trim() + '*'
      + "' OR ownerEmail:" + '*' + value.trim() + '*' + "' "


    this.companiesService.getCompanyBySearchAll(search, this.page, this.size, sortParam).subscribe(
      res => {

        this.companyList = res['content'];


      },
      error => {

      })

  }

  getTagsData(value) {


    let sortParam = 'updatedDate' + "," + Constant.Dsc;

    let search = "name:" + '*' + value.trim() + '*'
      + "' OR statusName:" + '*' + value.trim() + '*'
      + "' OR active:" + '*' + value.trim() + '*' + "' "


    this.tagesStatusService.TagsSearch(search, this.page, this.size, sortParam, this.type).subscribe(
      res => {

        this.tagList = res['content'];




      },
      error => {

      })

  }



  getAllLeadDetails(leadId) {
    this.leadService.getAllLeadDetailsByEntityId(leadId).subscribe(
      data => {
        if (!data) return;
        this.leadId = data['entityId'];
        const nameVal = (data['name'] && data['name'].trim()) ? data['name'].trim() : '';
        const phoneVal = data['phoneNumber'] || data['mobile'] || data['phone'] || data['secondaryphoneno'] || '';
        this.leadName = nameVal ? nameVal : phoneVal;

        if (this.group && this.group.get('LeadId')) {
          this.group.get('LeadId').setValue(this.leadId);
        }
        if (this.group && this.group.get('LeadName')) {
          this.group.get('LeadName').setValue(this.leadName);
        }
        this.isOptionSelected = true;
        this.displayControl.setValue(this.leadName);

        console.log(this.group);
      },
      error => {

      })
  }

  getAllCompanyDetails(leadId) {
    this.companiesService.getAllCompainesAllByLeadId(leadId).subscribe(
      data => {


        this.leadId = data['entityId'];

        this.leadName = data['name'];
        this.group.get('CompanyId').setValue(this.leadId);
        this.group.get('Company').setValue(this.leadName);
        this.isOptionSelected = true;
        this.displayControl.setValue(this.leadName);

        console.log(this.group);



      },
      error => {

      })
  }

  getAllDealsCompanyDetails(leadId) {
    this.companiesService.getAllLeadDetailsByEntityId(leadId).subscribe(
      data => {


        this.leadId = data['entityId'];

        this.leadName = data['name'];
        this.group.get('CompanyId').setValue(this.leadId);
        this.group.get('Company').setValue(this.leadName);
        this.isOptionSelected = true;
        this.displayControl.setValue(this.leadName);

        console.log(this.group);



      },
      error => {

      })
  }


  getAllTagsDetails(leadId) {
    this.tagesStatusService.getTagsById(leadId).subscribe(
      data => {


        this.leadId = data['entityId'];

        this.leadName = data['name'];
        this.group.get('TagId').setValue(this.leadId);
        this.group.get('TagName').setValue(this.leadName);
        this.isOptionSelected = true;
        this.displayControl.setValue(this.leadName);

        console.log(this.group);



      },
      error => {

      })
  }

  onProductInput(event: Event): void {
    let inputElement = event.target as HTMLInputElement;
    // remove leading spaces as user types
    const raw = inputElement.value || '';
    const noLeading = raw.replace(/^\s+/, '');
    if (noLeading !== raw) {
      inputElement.value = noLeading;
    }
    let inputValue = noLeading.trim();

    if (inputValue.length > 0) {
      this.getProductData(inputValue);

    }

    this.attachScrollListenersForElement(inputElement);

  }
  getProductData(value) {


    let sortParam = 'id' + "," + Constant.Dsc;
    let searchTerm = "name:" + '*' + value.trim() + '*'
      + "' OR sku:" + '*' + value.trim() + '*' + "' "



    this.productService.getProductBySearch(searchTerm, this.page, this.size, sortParam).subscribe(
      res => {

        this.productList = res['content'];


      },
      error => {

      })

  }

  clearInputProduct() {
    this.isOptionSelected = false;

    this.group.get('ProductId')?.reset();

    this.group.get('ProductName')?.reset();

    // Close any open autocomplete panels and detach scroll listeners
    try { this.closeAllAutocompletePanels(); } catch (e) { /* ignore if not available */ }
  }

  onProductSelected(event, option) {
    if (event.isUserInput != false) {
      this.isOptionSelected = true;
      const prodId = option.entityId || option.id || option.productId;
      this.group.get('ProductId').setValue(prodId);
      this.group.get('ProductName').setValue(option.name);

    }
  }

  onPropertyInput(event: Event): void {
    let inputElement = event.target as HTMLInputElement;
    const raw = inputElement.value || '';
    const noLeading = raw.replace(/^\s+/, '');
    if (noLeading !== raw) {
      inputElement.value = noLeading;
    }
    let inputValue = noLeading.trim();

    if (inputValue.length > 0) {
      this.getPropertyData(inputValue);
    }

    this.attachScrollListenersForElement(inputElement);
  }

  get filteredPropertyList(): any[] {
    if (!this.propertyList) return [];
    if (!this.selectedProperties || this.selectedProperties.length === 0) return this.propertyList;
    return this.propertyList.filter(opt => {
      const optId = opt.entityId || opt.id;
      const optName = (opt.propertyName || opt.name || '').toString().toLowerCase().trim();
      return !this.selectedProperties.some(sp => {
        const spId = sp.entityId || sp.id;
        const spName = (sp.propertyName || sp.name || '').toString().toLowerCase().trim();
        return (optId != null && spId != null && optId == spId) || (optName.length > 0 && spName.length > 0 && optName === spName);
      });
    });
  }

  getPropertyData(value) {
    let sortParam = 'updatedDate' + "," + Constant.Dsc;
    let searchTerm = "propertyName:'" + '*' + value + '*'
      + "'  OR status:'" + '*' + 1 + ',*'
      + "' "


    this.realEstatePropertyService.searchProperties(searchTerm, this.page, this.size, sortParam).subscribe(
      res => {
        this.propertyList = res['content'];
      },
      error => {
      })
  }

  onPropertyOptionSelected(eventOrOption: any): void {
    const option = eventOrOption?.option?.value || eventOrOption;
    if (!option || typeof option === 'string') return;
    const propId = option.entityId || option.id;
    const propName = option.propertyName || option.name;

    if (propName || propId) {
      if (!this.selectedProperties.some(p => (p.entityId == propId || p.id == propId || p.propertyName == propName || p.name == propName))) {
        this.selectedProperties.push({
          entityId: propId,
          id: propId,
          name: propName,
          propertyName: propName
        });
      }
    }

    this.updatePropertyFormGroup();

    this.propertyCtrl.setValue('');
    if (this.propertyInput) {
      this.propertyInput.nativeElement.value = '';
    }
    this.cdr.detectChanges();
  }

  removeProperty(item: any): void {
    const index = this.selectedProperties.indexOf(item);
    if (index >= 0) {
      this.selectedProperties.splice(index, 1);
      this.updatePropertyFormGroup();
      this.cdr.detectChanges();
    }
  }

  updatePropertyFormGroup(): void {
    if (!this.group) return;

    const ids = this.selectedProperties.map(p => p.entityId || p.id).filter(id => id != null && id !== '').join(',');
    const names = this.selectedProperties.map(p => p.propertyName || p.name).filter(n => n != null && n !== '').join(',');

    this.isOptionSelected = this.selectedProperties.length > 0;

    const idControls = ['PropertyId', 'propertyId', 'PrimaryPlan', 'primaryPlan'];
    idControls.forEach(ctrlName => {
      if (this.group.get(ctrlName)) {
        this.group.get(ctrlName).setValue(ids, { emitEvent: false });
      }
    });

    const nameControls = ['PropertyName', 'propertyName', 'Property', 'property'];
    nameControls.forEach(ctrlName => {
      if (this.group.get(ctrlName)) {
        this.group.get(ctrlName).setValue(names, { emitEvent: false });
      }
    });

    if (this.field && this.field.attributeCode && this.group.get(this.field.attributeCode)) {
      const fieldCode = this.field.attributeCode;
      const valToSet = (fieldCode.toLowerCase().includes('id') || fieldCode === 'PrimaryPlan' || fieldCode === 'primaryPlan') ? ids : names;
      this.group.get(fieldCode).setValue(valToSet, { emitEvent: false });
    }
  }

  clearInputProperty() {
    this.isOptionSelected = false;
    this.lastFetchedPropertyId = null;
    this.selectedProperties = [];
    this.updatePropertyFormGroup();
    this.propertyList = [];
    this.propertyCtrl.setValue('');
    if (this.propertyInput) {
      this.propertyInput.nativeElement.value = '';
    }
    try { this.closeAllAutocompletePanels(); } catch (e) { /* ignore if not available */ }
    this.cdr.detectChanges();
  }

  onPropertySelected(event, option) {
    if (option) {
      this.onPropertyOptionSelected({ option: { value: option } });
    }
  }

  getAllPropertyDetails(propertyId) {
    if (!propertyId) return;
    this.lastFetchedPropertyId = propertyId;
    this.realEstatePropertyService.getPropertyById(propertyId).subscribe(
      data => {
        if (!data) return;
        const propName = data['propertyName'] || data['name'];
        const propId = data['entityId'] || propertyId;

        if (!this.selectedProperties.some(p => (p.entityId == propId || p.id == propId || p.name == propName))) {
          this.selectedProperties.push({
            entityId: propId,
            id: propId,
            name: propName,
            propertyName: propName
          });
          this.updatePropertyFormGroup();
        }
        this.isOptionSelected = true;
        this.cdr.detectChanges();
      },
      error => {
      });
  }

  /**
   * Called when an autocomplete panel closes. If the current control value
   * does not exactly match any option (case-insensitive), clear the typed value
   * and the associated Id control so an invalid free-text entry isn't kept.
   */
  onAutocompleteClosed(controlName: string) {
    const control = this.group.get(controlName);
    if (!control) {
      return;
    }
    // If Company or LeadName control and Id is already selected or option is selected, preserve it and do nothing
    if ((controlName === 'Company' && ((this.group && this.group.value && this.group.value.CompanyId > 0) || this.isOptionSelected)) ||
        (controlName === 'LeadName' && ((this.group && this.group.value && this.group.value.LeadId > 0) || this.isOptionSelected))) {
      return;
    }
    if (this.isPropertyField() && (this.isOptionSelected || (this.group && this.group.value && (this.group.value.PropertyId > 0 || this.group.value.propertyId > 0 || this.group.value.PrimaryPlan > 0 || this.group.value.primaryPlan > 0)))) {
      return;
    }
    const typed = (control.value || '').toString().trim();
    if (!typed) {
      return;
    }

    let list: any[] = [];
    let idControlName: string | null = null;

    if (controlName === 'Company') {
      list = this.companyList || [];
      idControlName = 'CompanyId';
    } else if (controlName === 'LeadName') {
      list = this.leadList || [];
      idControlName = 'LeadId';
    } else if (controlName === 'ProductName') {
      list = this.productList || [];
      idControlName = 'ProductId';
    } else if (controlName === 'PropertyName' || controlName === 'propertyName' || controlName === 'Property' || controlName === 'PrimaryPlan' || controlName === 'primaryPlan') {
      list = this.propertyList || [];
      idControlName = this.group.get('PropertyId') ? 'PropertyId' : (this.group.get('propertyId') ? 'propertyId' : (this.group.get('PrimaryPlan') ? 'PrimaryPlan' : (this.group.get('primaryPlan') ? 'primaryPlan' : null)));
    }

    const match = list.find(opt => {
      const nameVal = (opt.name && opt.name.trim()) ? opt.name.trim() : (opt.phoneNumber || opt.mobile || opt.phone || opt.secondaryphoneno || '');
      const optName = (opt.propertyName || nameVal || '') + '';
      return optName.toLowerCase() === typed.toLowerCase();
    });

    // If no exact match found, clear the typed value and its id
    if (!match) {
      control.reset();
      if (idControlName && this.group.get(idControlName)) {
        this.group.get(idControlName).reset();
      }
      this.isOptionSelected = false;
    }
  }

  // Close any open autocomplete panels when the user scrolls the page.
  // This ensures the (closed) event fires and our onAutocompleteClosed handler runs.
  @HostListener('window:scroll', ['$event'])
  @HostListener('document:scroll', ['$event'])
  onWindowOrDocumentScroll(_event: Event) {
    this.closeAllAutocompletePanels();
  }

  closeAllAutocompletePanels() {
    if (!this.autocompleteTriggers) {
      return;
    }
    this.autocompleteTriggers.forEach(trigger => {
      try {
        if (trigger && trigger.panelOpen) {
          trigger.closePanel();
        }
      } catch (e) {
        // ignore any errors closing triggers
      }
    });
    // whenever we programmatically close panels, also detach any scroll listeners we attached
    this.detachScrollListeners();
  }

  /**
   * Find scrollable ancestor elements of `el` and attach listeners that close
   * the autocomplete panel when those ancestors scroll.
   */
  private attachScrollListenersForElement(el: HTMLElement) {
    if (!el || !document) {
      return;
    }

    // detach existing listeners first to avoid duplication
    this.detachScrollListeners();

    // always include window as a fallback; listen for scroll, wheel and touchmove so horizontal scrolls and touch
    // gestures also close panels.
    const windowHandler = () => this.closeAllAutocompletePanels();
    window.addEventListener('scroll', windowHandler, { passive: true });
    window.addEventListener('wheel', windowHandler, { passive: true });
    window.addEventListener('touchmove', windowHandler, { passive: true });
    this._scrollableListeners.push({ el: window as unknown as HTMLElement, handler: windowHandler });

    // walk up the DOM tree and attach listeners to scrollable ancestors
    let parent: HTMLElement | null = el.parentElement;
    while (parent) {
      try {
        const style = getComputedStyle(parent);
        const overflowY = style.overflowY;
        const isScrollable = (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') && parent.scrollHeight > parent.clientHeight;
        if (isScrollable) {
          const handler = () => this.closeAllAutocompletePanels();
          parent.addEventListener('scroll', handler, { passive: true });
          parent.addEventListener('wheel', handler, { passive: true });
          parent.addEventListener('touchmove', handler, { passive: true });
          this._scrollableListeners.push({ el: parent, handler });
        }
      } catch (e) {
        // ignore cross-origin or other issues
      }
      parent = parent.parentElement;
    }
  }

  private detachScrollListeners() {
    if (!this._scrollableListeners || this._scrollableListeners.length === 0) {
      return;
    }
    this._scrollableListeners.forEach(item => {
      try {
        if (item.el === window) {
          try { window.removeEventListener('scroll', item.handler as EventListener); } catch (e) { }
          try { window.removeEventListener('wheel', item.handler as EventListener); } catch (e) { }
          try { window.removeEventListener('touchmove', item.handler as EventListener); } catch (e) { }
        } else if (item.el && item.handler) {
          try { item.el.removeEventListener('scroll', item.handler as EventListener); } catch (e) { }
          try { item.el.removeEventListener('wheel', item.handler as EventListener); } catch (e) { }
          try { item.el.removeEventListener('touchmove', item.handler as EventListener); } catch (e) { }
        }
      } catch (e) {
        // ignore
      }
    });
    this._scrollableListeners = [];
  }


  addNewCompany(companyName?: string) {
    // Read trimmed company name either from parameter or from the form control
    const raw = (companyName !== undefined && companyName !== null) ? companyName : (this.group?.value?.Company ?? '');
    const name = ('' + raw).toString().trim();

    if (!name) {
      // nothing to add
      return;
    }

    // ensure the form control stores the trimmed value (remove leading/trailing spaces)
    if (this.group && this.group.get('Company')) {
      this.group.get('Company').setValue(name);
    }

    this.isOptionSelected = true; // Mark selected immediately to prevent auto-reset when panel closes

    this.loaderService.show();

    const object = {
      company: name,
      owner: this.group.value.Owner || null,
      ownerId: this.group.value.OwnerId || null,
      entityId: this.group.get('CompanyId')?.value || null,
    };

    this.companiesService.addCompanyName(object).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

          this.loaderService.hide();

          console.log("response", response);


          if (response['data'] && response['data']['entityId']) {
            this.isOptionSelected = true;
            if (this.group.get('CompanyId')) {
              this.group.get('CompanyId').setValue(response['data']['entityId']);
              this.group.get('CompanyId').updateValueAndValidity();
            }
            if (this.group.get('Company')) {
              this.group.get('Company').setValue(response['data']['name'] || name);
              this.group.get('Company').markAsUntouched();
              this.group.get('Company').markAsPristine();
              this.group.get('Company').updateValueAndValidity();
            }
            if (this.field && this.field.attributeCode && this.field.attributeCode !== 'Company' && this.group.get(this.field.attributeCode)) {
              this.group.get(this.field.attributeCode).setValue(response['data']['name'] || name);
              this.group.get(this.field.attributeCode).markAsUntouched();
              this.group.get(this.field.attributeCode).markAsPristine();
              this.group.get(this.field.attributeCode).updateValueAndValidity();
            }
            this.cdr.detectChanges();
          }

          this.loaderService.hide();
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
        } else {
          this.isOptionSelected = false;
          this.loaderService.hide();
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      (err) => {
        this.isOptionSelected = false;
        this.loaderService.hide();
      });
  }





  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  protected _onDestroy = new Subject<void>();
}
